export default __webpack_public_path__ + "static/media/matic.4f351584.svg";